"use client";
import classNames from "classnames";
import styles from "./VotingButton.module.css";
import { useState } from "react";
import VotingForm from "src/components/votingbutton/VotingForm";
import OverlayPortal from "src/components/overlayportal/OverlayPortal";
import { IFilmomtale } from "src/lib/types/Filmomtale";
import { CSSProperties } from "styled-components";

//#region [Props]
type VotingButtonProps = {
    film?: IFilmomtale;
    className?: string;
    style?: CSSProperties;
    formClassName?: string;
    voteAppId: number;
    title: string;
    gdprId: number;
};
//#endregion

//#region [Component]
export default function VotingButton({ className, formClassName, film, voteAppId, title, gdprId, style }: VotingButtonProps) {
    const [isShowingForm, showForm] = useState(false);

    return <>
        <button className={classNames(styles.VotingButton, className)} onClick={() => showForm(true)}>Stem på filmen</button>
        {isShowingForm && <OverlayPortal doClose={() => showForm(false)} hideClose style={style}><div className={styles.FormAligner} ><VotingForm gdprId={gdprId} voteAppId={voteAppId} doClose={() => showForm(false)} className={formClassName} title={title} film={film!} /></div></OverlayPortal>}
    </>
}
//#endregion
